import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'storagePath'
})
export class StoragePathPipe implements PipeTransform {
  constructor() {

  }
  transform(value: string, args?: any): any {
    if (value) {
      if (value.indexOf("UserIcon.png") != -1) {
        value = "UserIcon.png";
      } else if (value.indexOf("no-image.png") != -1) {
        value = "no-image.png";
      }
      return environment.storagePath + value + "?alt=media"
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_pipe/storage-path.pipe.ts